import { ValueTransformer } from 'typeorm'

/** Typeorm values transformer that transforms decimal column type values to
 * typescript numbers without losing precision */
export class ColumnDecimalTransformer implements ValueTransformer {
	to(data: number): number {
		return data
	}
	from(data: string): number {
		return Number.parseFloat(data)
	}
}
